// Lightweight WebGL2 feature detection — intentionally tiny and
// free of any shader code so it can be imported without pulling the
// deck engine into the bundle. Used to gate the dynamic import of
// `deck.mjs` and avoid downloading shader strings on incapable devices.

/**
 * Returns true if the current environment supports WebGL2 rendering.
 * Safe to call on server (returns false) and in browsers where canvas
 * or getContext is unavailable.
 */
export function hasWebGL2() {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return false;
  }
  try {
    const canvas = document.createElement("canvas");
    // Use same context attributes as deck.mjs init to ensure parity
    const gl = canvas.getContext("webgl2", { alpha: true, antialias: false });
    if (gl) {
      // Immediately lose context to free GPU resources from probe
      const loseExt = gl.getExtension("WEBGL_lose_context");
      if (loseExt) loseExt.loseContext();
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

/**
 * Synchronous check for `prefers-reduced-motion` or other opt-outs could
 * be added here in the future. Keeping as a separate function for testability.
 */
export function shouldLoadShaders() {
  return hasWebGL2();
}
